
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_41291)"}},[_c('path',{attrs:{"d":"M9.076 10.405a3.857 3.857 0 100-7.714 3.857 3.857 0 000 7.714zM16.788 23.262H1.359v-1.714a7.714 7.714 0 0115.429 0v1.714zM15.934 2.691a3.857 3.857 0 110 7.714M18.676 14.16a7.714 7.714 0 014.971 7.2v1.903h-2.571"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_41291"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .12)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    